'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';

const NoAdsAccess = () => /*#__PURE__*/_jsx(UIErrorMessage, {
  illustration: "lock",
  illustrationProps: {
    width: 200
  },
  title: /*#__PURE__*/_jsx("h3", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "noAdsAccess.title"
    })
  }),
  children: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "noAdsAccess.message"
    })
  })
});

export default NoAdsAccess;